import { useLiteMode as useLiteModeCore } from '@/connection/hooks';

// Pure leaf hook - just wraps context, no side effects
export const useLiteMode = () => {
  const isLiteMode = useLiteModeCore();
  
  return {
    isLiteMode,
    // Legacy compatibility - these are now handled by SimpleConnectionProvider
    isAutoDetected: false,
    toggleLiteMode: () => console.warn('Use connection mode selector instead'),
    isForcedByFeatureFlag: false,
    storageType: 'memory',
    isStorageBlocked: false
  };
};